(function (angular, app) {
    'use strict';

    app.service('GoogleLoginService', ['$rootScope', 'Api', '$q', 'User',
        function ($rootScope, Api, $q, User) {
            var self = this;
            var loginSuccess = false;

            angular.extend(self, {
                loginWithGoogle: loginWithGoogle,
            });

            function loginWithGoogle(code) {
                loginSuccess = false;
                return loginWithGoogleRequest(code)
                    .then(function(response) {
                        return _handleGoogleLoginResponse(response);
                    })
                    .catch(function(error) {
                        loginSuccess = false;
                        return $q.reject(error);
                    })
                    .finally(function() {
                        _handleFinally();
                    });
            }

            function loginWithGoogleRequest(code) {
                return Api.request({
                    method: 'POST',
                    url: '/v2/retailers/:rid/sessions/google',
                    params: {
                        platform: 'WEB'
                    },
                    data: {  code: code },
                },{ withoutToast: true  });
            }

            function _handleGoogleLoginResponse(response) {
                if(response.data) {
                    return $q.resolve(response);
                }
                
                var defer = $q.defer();
                loginSuccess = true;
                User.userLoggedInSuccessfullySetSession(response, defer, response.email);
                return defer.promise;
            }

            function _handleFinally() {
                $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_LOGIN_ATTEMPT, {
                    loginMethod: 'Google',
                    loginSuccess: loginSuccess,
                    OTPSent: false
                });
            }
        },
    ]);
})(angular, app);